import { useComputedColorScheme, useMantineColorScheme } from '@mantine/core';
import type { IUseColorSchemeToggleReturn } from './types';

export function useColorSchemeToggle(): IUseColorSchemeToggleReturn {
  const { setColorScheme } = useMantineColorScheme();
  const computedColorScheme = useComputedColorScheme('light');
  const isDark = computedColorScheme === 'dark';

  const toggleColorScheme = (): void => {
    setColorScheme(isDark ? 'light' : 'dark');
  };

  return { isDark, toggleColorScheme };
}
